import script from "./Match.vue?vue&type=script&lang=ts&setup=true"
export * from "./Match.vue?vue&type=script&lang=ts&setup=true"

import "./Match.vue?vue&type=style&index=0&id=c70fc2c2&lang=css"

const __exports__ = script;

export default __exports__